import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function ModelIcon({ ...props }) {
  return (
    <SvgIcon width="14" height="20" viewBox="0 0 14 20" {...props}>
      <path d="M13.3318 8.85911L9.28051 6.04591C8.37655 5.41596 6.89803 4.38996 5.99223 3.76256L1.79239 0.949294C0.888731 0.31942 0 0.824636 0 2.07249V17.9291C0 19.1726 0.888731 19.68 1.79275 19.0526L5.91831 16.2394C6.82411 15.612 8.34069 14.586 9.24465 13.9561L13.3151 11.1429C14.2169 10.5129 14.234 9.4865 13.3318 8.85911Z" />
    </SvgIcon>
  );
}
